export const EMAIL_QUEUE_STATUS = { pending: 0, inProgress: 1, succeeded: 2, failed: 3, cancelled: 4 } as const
export type EmailQueueStatus = typeof EMAIL_QUEUE_STATUS[keyof typeof EMAIL_QUEUE_STATUS]

export default interface IEmailQueue {
  id: number;
  referenceHash: string;
  status: EmailQueueStatus;
  retryCount: number;
  nextRetryAt: Date;
  createdAt: Date;
  updatedAt: Date;
}
